import { Action } from 'util/domain';
import { 
	Menu,
	MenuPriority 
} from 'sharebase/domain';

export interface IMenuItem {
	action:string;
	label:string;
	icon:string;
	trigger:MenuItemTrigger;
	context:MenuItemContext;
	priority?:MenuPriority;
	readonly visible:boolean;
	addValidator<T>(validator:MenuItemValidator<T>, priority?:ValidatorPriority):Action;
	removeAllValidators():IMenuItem;
	addTrigger(trigger:MenuItemTrigger):Action;
	removeAllTriggers():IMenuItem;	
	addMiddleware(middleware:MenuItemMiddleware):Action;
	removeAllMiddleware():IMenuItem;
	canShow(target?:any): ng.IPromise<boolean>;
	clone():IMenuItem;
}

export enum MenuItemContext {
    None = 'NONE',
    SelectionBar = 'SELECTION_BAR',
	ContextMenu = 'CONTEXT_MENU',
	Toolbar = 'TOOLBAR'
};

export interface MenuItemConfig {
	action: string;
	label: string;
	icon: string;
	trigger?: MenuItemTrigger;
	validator?: MenuItemValidator<any>;
}

export interface MenuItemTrigger {
	(target: any, event?:ng.IAngularEvent):void|ng.IPromise<any>;
}

export enum ValidatorPriority {
	Low,
	Medium,
	High
}

export interface MenuItemMiddleware {
	(target:any):any;
}

export interface MenuItemValidator<T> {
	(target:T, all:T[], original:T):boolean|ng.IPromise<boolean>;
	priority?: ValidatorPriority;
}


// WEBPACK FOOTER //
// ./src/sharebase/domain/sharebase-menu.ts